import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function GameShell({ title, intro, children, testId, instructions }) {
    return (
        <main
            className="container-page py-12 max-w-3xl fade-up"
            data-testid={testId}
            data-game-instructions={instructions || undefined}
        >
            <Link to="/app/games" className="inline-flex items-center gap-2 text-[#515B57] hover:text-[#2D5D4E] mb-6" data-testid="game-back">
                <ArrowLeft className="w-4 h-4" /> All games
            </Link>
            <p className="label-eyebrow mb-2">Game</p>
            <h1 className="text-4xl font-semibold text-[#1C2321] mb-3" style={{ fontFamily: "Outfit" }}>{title}</h1>
            {intro && <p className="text-lg text-[#515B57] mb-8">{intro}</p>}
            {children}
        </main>
    );
}

export function shuffle(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
}

/**
 * Weighted-random pick: items with higher `weight` (derived from the
 * learner's per-grapheme mistake count on the server) surface more often.
 * Falls back to uniform random if no items carry a weight field.
 */
export function pickWeighted(items) {
    if (!items || items.length === 0) return null;
    const total = items.reduce((s, it) => s + (it.weight || 1), 0);
    let r = Math.random() * total;
    for (const it of items) {
        r -= it.weight || 1;
        if (r <= 0) return it;
    }
    return items[items.length - 1];
}
